import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { moviesAndOva } from "@/mocks/anime";

const kindTabs = ["全部", "剧场版", "OVA"];

export default function Movies() {
  const [kind, setKind] = useState("全部");

  const list = kind === "全部" ? moviesAndOva : moviesAndOva.filter((item) => item.kind === kind);

  return (
    <section id="movies" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
        <SectionHeading
          eyebrow="大屏与短篇"
          icon="ri-movie-2-line"
          title="剧场版与 OVA · 有电影感的长篇，也有补完正片的短篇"
          description="剧场版适合整段空闲时间一口气看完，OVA 则多为番外或外传，篇幅短、情绪集中。用下面的切换可以只看其中一类。"
        />
        <div className="flex gap-1 p-1 rounded-full bg-background-100 border border-background-200/70 mb-8 md:mb-10 lg:mb-10 shrink-0">
          {kindTabs.map((tab) => (
            <button
              key={tab}
              type="button"
              onClick={() => setKind(tab)}
              aria-pressed={kind === tab}
              className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                kind === tab
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:text-primary-700"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
        {list.map((item) => (
          <article
            key={item.id}
            className="group flex gap-4 rounded-lg overflow-hidden bg-background-100 border border-background-200/70 p-3 md:p-4 transition-colors hover:border-primary-300"
          >
            <div className="relative w-28 sm:w-32 md:w-36 shrink-0 rounded-md overflow-hidden bg-background-200">
              <div className="w-full h-40 sm:h-44 md:h-48">
                <img
                  src={item.cover}
                  alt={`${item.title} 封面`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-foreground-950 text-xs font-medium">
                {item.kind}
              </span>
            </div>
            <div className="flex-1 min-w-0 flex flex-col">
              <div className="flex items-start justify-between gap-2">
                <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950">
                  {item.title}
                </h3>
                <span className="shrink-0 flex items-center gap-1 text-sm font-semibold text-primary-700">
                  <i className="ri-star-fill" aria-hidden="true"></i>
                  {item.rating.toFixed(1)}
                </span>
              </div>
              <div className="mt-2 flex flex-wrap gap-x-3 gap-y-1 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-earth-line" aria-hidden="true"></i>
                  {item.region}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-timer-line" aria-hidden="true"></i>
                  {item.duration}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line" aria-hidden="true"></i>
                  {item.year} 年
                </span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 line-clamp-3 md:line-clamp-4">
                {item.summary}
              </p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}